import { OverlayContainer } from "@angular/cdk/overlay";
import { Component, Renderer2, inject } from "@angular/core";
import * as moment from "moment";
import { IdleService } from "../services/idle.service";
import { NotificationService } from "../services/notification.service";
import { SettingsService } from "../services/settings.service";

@Component({
    selector: "nx-menu-and-navigation",
    templateUrl: "./menu-and-navigation.component.html",
    styleUrls: ["./menu-and-navigation.component.scss"],
    standalone: false
})
export class MenuAndNavigationComponent {
  notificationService = inject(NotificationService);
  settingsService = inject(SettingsService);
  idleService = inject(IdleService);
  private _overlayContainer = inject(OverlayContainer);
  private _renderer = inject(Renderer2);

  constructor() {
    moment.locale("de");

    this._renderer.addClass(document.body, this.settingsService.theme);
    this._overlayContainer.getContainerElement().classList.add(this.settingsService.theme);
  }
}
